import { privateApi, publicApi } from "./api.interceptor"

class UserService {

  login = (data)  => publicApi.post("/users/login", data)
  changeAvatar = (id, file) => privateApi.patch(`/users/profile-picture/${id}`, file,{
    headers: {'content-type': 'multipart/form-data'}
  })
  getAllUsers = () => privateApi.get('/users');
  getUser = (id) => privateApi.get(`/users/${id}`);
  delete = (id) => privateApi.delete(`/users/${id}`);
  update = (data) => privateApi.put(`/users/${data['id']}`, data);
  create = (data) => privateApi.post(`/users/register`, data);
  resetCommande = (data)  => privateApi.post("/users/resetCommandes",data)
}

export default new UserService();
